/** Component for My Account functions */

/** Update Memberson integration */
/** 08072024: Add functionality to convert to shopify vouchers */


export function myAccountCommon(){
    var _THIS = this;
    this.form = null;



    this.initForm = function(form){
        _THIS.form = form;
        (async () => {
            const { styleForm } = await import(theme.components.commonURL);
            var instStyleForm = new styleForm();
            instStyleForm.init();
        })();


    }

    this.displayFormErrors = function(arrErrors){

        var htmlErrorList = ""
        for(var i=0;i<arrErrors.length;i++){
            htmlErrorList += "<li>" + arrErrors[i] + "</li>"
        }

        if(htmlErrorList!==""){
            _THIS.form.find(".form-message").removeClass("form-message--error").removeClass("form-message--success")
            _THIS.form.find(".form-message .form-message-inner").html("<ul>" + htmlErrorList + "</ul>")

            _THIS.form.find(".form-message").addClass("form-message--error")
            _THIS.form.find(".form-message").removeClass("hide")
    
        }

        if(_THIS.form.find(".invalid").length > 0){
            $([document.documentElement, document.body]).animate({
                scrollTop: _THIS.form.find(".invalid").eq(0).offset().top - ($("#shopify-section-header").length >0?$("#shopify-section-header").height():0)
            }, 500);
        }
    }
    
    this.hideFormErrors = function(){
        _THIS.form.find(".form-message").addClass("hide")
        _THIS.form.find(".form-message").removeClass("form-message--error").removeClass("form-message--success")
        _THIS.form.find(".form-message .form-message-inner").html("")
    }

    this.initSideMenu = function(){
        $(document).on("click","#show-side-menu",function(e){
            e.preventDefault();
            $("#side-menu").addClass("active")
        })

        $(document).on("click","#side-menu-close, .side-menu-overlay",function(e){
            e.preventDefault();
            $("#side-menu").removeClass("active")
        })
    }

    this.initPasswordFields = function(field){
        $(document).on("click",".password-reveal",function(e){
            e.preventDefault();
            var parentFld = $(this).closest(".password-field");
            if(parentFld.length > 0){
                if(parentFld.hasClass("reveal")){
                    parentFld.removeClass("reveal")
                    parentFld.find(".inppassreveal").attr("type","password").removeClass("inppassreveal")
                }else{
                    parentFld.addClass("reveal")
                    parentFld.find("input[type=password]").attr("type","text").addClass("inppassreveal")
                }
            }
        })
    }

    this.initCharCounter = function(field,len){
        field.after('<div class="field-note field-counter"><span></span></div>')
        field.prop("maxlength",len)
        field.prop("size",len)

        field.on("keydown keyup paste blur change",function(){
            
            _THIS.updateCharCounter(field);
        })			
        _THIS.updateCharCounter(field);
    
    }
    
    this.updateCharCounter = function(field){
        
        var counterField = field.parent().find(".field-counter span")
        var fieldLength = field.val();
        var mxlen = field.prop("maxlength")
            mxlen = mxlen * 1;
        if(mxlen >= 0){
            
            if(fieldLength.length > mxlen){
                
                field.val(field.val().substr(0,mxlen))
            }
            var calchar = (mxlen - (fieldLength.length));
            if(calchar <=0){calchar=0};
            counterField.text( calchar + " " + theme.forms.general.charactersLeft )
        }
    }
        
    

    
    this.validatePassWord = function(fld){
        var isPasswordValid = true;
        var passFld = $(fld)
        var passVal = $.trim($(fld).val());
        if(passVal.length <= 0){
            isPasswordValid = false;
        }else{

            var re= /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d[\]{}\(\);:=<>_\~\`\+^#$@\!%*-?&\|]{8,}$/
            //var re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])\w{8,}$/;
            isPasswordValid = re.test(passVal)
        }
       // console.log("isPasswordValid: " + isPasswordValid)
        if(isPasswordValid){
            passFld.removeClass("invalid")
        }else{
            passFld.addClass("invalid")
        }

        return isPasswordValid

    }


    this.loyaltyCreateHiddenFields = function(form){
        if(form.find("input[name=bt_check]").length <=0){
            form.append('<input type="text" name="bt_check" value="" style="display:none !important" tabindex="-1" autocomplete="off">')
        }
        
        if(form.find("input[name=lan]").length <=0){
            form.append('<input type="text" name="lan" value="' + theme.devSettings.shopLocale + '" style="display:none !important" tabindex="-1" autocomplete="off">') 
        }
        

    }
}


export function myAccountForgotPassword(){
    
    var _THIS = this;
    this.formString = "#recover_customer_password"
    this.form = $(_THIS.formString);
    this.instCommon = new myAccountCommon();
    this.instCommon.initForm(this.form)
    this.init=function(){
       // console.log("initialising My Account Forgot password")
        registerEvents();


        if(theme.loyalty.enable){
            _THIS.instCommon.loyaltyCreateHiddenFields(_THIS.form)
        }


    }    

    var registerEvents  = function(){


        $(document).on("click","#recover_customer_password input[type=submit]",function(e){
            _THIS.submitForm(e);
        })


        $(document).on("click",".forgot-password",function(){
            _THIS.resetForm();
            
        })

    }

    this.resetForm = function(){
        $("#RecoverEmail").removeClass("invalid")
    }

    this.submitForm = function(e){
        
   
        var validFormResult = _THIS.validateForm();
        e.preventDefault();
        if(!validFormResult.isFormValid){
            _THIS.instCommon.displayFormErrors(validFormResult.messages.error)
        }else{
            if(theme.loyalty.enable == true){
                
                if( _THIS.form.find("input[name='bt_check']").length > 0){
                    if(_THIS.form.find("input[name='bt_check']").val()!==""){
                        return;
                    }
                };

                (async () => {
                    const { UISubmitForgetPasswordForm } = await import(theme.components.loyaltyURL);
                    //console.log("submitting to loyalty")
                    UISubmitForgetPasswordForm(_THIS.formString);
                    
                })();
    


            }else{
                _THIS.form.submit();
               // console.log("submitting to Shopify")
            }
        }
    }


    this.validateForm = function(){

        _THIS.instCommon.hideFormErrors();

        var retObj = {
            isFormValid: true,
            messages:{
                error: [],
                success:[] 
            }
        }

        var mandatoryFields = ["#RecoverEmail"]

        for(var i=0;i<mandatoryFields.length;i++){
            var fld = _THIS.form.find(mandatoryFields[i])
            var fldVal = fld.val();
            if($.trim(fldVal).length <= 0) {
                fld.addClass("invalid")
                retObj.isFormValid = false;
            }else{
                fld.removeClass("invalid")
            }
        }

        if(!retObj.isFormValid){
            retObj.messages.error.push(theme.forms.general.mandatory)
        }

        return retObj; 
    }




}


export function myAccountLogin(){
    var _THIS = this;
    this.formString = "#customer_login";
    this.form = $("#customer_login")
    this.instCommon = new myAccountCommon();
    this.instCommon.initForm(this.form)
    this.instForgotPassword = new myAccountForgotPassword();
    this.instLoyaltyLogin = null;

    this.init=function(){
       // console.log("initialising My Account Login")
        registerEvents();
        if(!theme.loyalty.enable){
            checkForgotPasswordForm()
        }else{
            _THIS.instCommon.loyaltyCreateHiddenFields(_THIS.form)
        }
        
        _THIS.instCommon.initPasswordFields();

    }    


    var registerEvents  = function(){


        $(document).on("click","#customer_login input[type=submit]",function(e){
            _THIS.submitForm(e);
        })



        _THIS.instForgotPassword.init();
    }

    var checkForgotPasswordForm = function(){
        //When submitting the forgot password form with shopify flow
        //If correct email is set then redirection will be on /login page
        //This is to allow showing the forget password form on load with
        //Success message
        
        if($("#recover_customer_password .form-message--success").length > 0){

            window.history.pushState(null,null,"#recover")
            window.location.href = window.location.href   
        }
    }


    this.submitForm = function(e){
        
   
        var validFormResult = _THIS.validateForm();
        e.preventDefault();
        if(!validFormResult.isFormValid){
            _THIS.instCommon.displayFormErrors(validFormResult.messages.error)
        }else{
            if(theme.loyalty.enable == true){
                
                if( _THIS.form.find("input[name='bt_check']").length > 0){
                    if(_THIS.form.find("input[name='bt_check']").val()!==""){
                        return;
                    }
                };

                (async () => {
                    const { UISubmitLoginForm } = await import(theme.components.loyaltyURL);
                    //console.log("submitting to loyalty")
                    UISubmitLoginForm(_THIS.formString);
                    
                })();
    



                
            }else{
                _THIS.form.submit();
                //console.log("submitting to Shopify")
            }
        }
    }

   

    this.validateForm = function(){

        _THIS.instCommon.hideFormErrors();
        

        var retObj = {
            isFormValid: true,
            messages:{
                error: [],
                success:[] 
            }
        }

        var mandatoryFields = ["#CustomerEmail", "#CustomerPassword"]

        for(var i=0;i<mandatoryFields.length;i++){
            var fld = _THIS.form.find(mandatoryFields[i])
            var fldVal = fld.val();
            if($.trim(fldVal).length <= 0) {
                fld.addClass("invalid")
                retObj.isFormValid = false;
            }else{
                fld.removeClass("invalid")
            }
        }

        if(!retObj.isFormValid){
            retObj.messages.error.push(theme.forms.general.mandatory)
        }

        return retObj; 
    }

}


export function myAccountAddresses(){
    var _THIS = this;
    this.isPostCodeMandatory = true;
    this.addForm = $("#address_form_new");
    this.insEditPhoneValidaton = null;

    this.instCommon = new myAccountCommon(); //more general functions

    this.instCommonEdit = null;
    this.instCommonAdd = new myAccountCommon();
    this.instCommonAdd.initForm(this.addForm)

    this.init=function(){
       // console.log("initialising My Account Addresses");

       

        setCharCounter();
        registerEvents();
        
    }    

    var setCharCounter = function(){
        //will apply event on add form and all edit forms
        $("input[name='address[first_name]']").each(function(){
            _THIS.instCommon.initCharCounter($(this),20)
        })

        $("input[name='address[last_name]']").each(function(){
            _THIS.instCommon.initCharCounter($(this),20)
        })

        $("input[name='address[company]']").each(function(){
            _THIS.instCommon.initCharCounter($(this),35)
        })


        $("input[name='address[address1]']").each(function(){
            _THIS.instCommon.initCharCounter($(this),40)
        })

        $("input[name='address[address2]']").each(function(){
            _THIS.instCommon.initCharCounter($(this),40)
        })


        $("input[name='address[city]']").each(function(){
            _THIS.instCommon.initCharCounter($(this),40)
        })


        $("input[name='address[phone]']").each(function(){
            
            _THIS.instCommon.initCharCounter($(this),30)
        });

  





    }
    
    var registerEvents  = function(){

        $(document).on("click",".address-edit-toggle",function(e){
            e.preventDefault();
            _THIS.showAddressEditForm($(this))
        })
        
        $(document).on("click",".address-delete",function(e){
            e.preventDefault();
            _THIS.deleteAddress($(this))
        })
    
    
        $(document).on("click",".address-edit-cancel",function(e){
            e.preventDefault();
            _THIS.cancelEditAddress($(this))
        })
    
        
        $(document).on("click",".add-new-address",function(e){
            e.preventDefault();
            _THIS.showAddressNewForm($(this))
        })
    
        $(document).on("click",".cancel-new-address",function(e){
            e.preventDefault();
            _THIS.hideAddressNewForm($(this))
        })
    
    
        //Save Edit Form
        $(document).on("click",".edit-address-forms form input.address-edit-save",function(e){
    
            _THIS.submitForm($(this).closest("form"),e,"edit");
        })
    
        //Save New Form
        $(document).on("click","#address_form_new .address-new-save",function(e){
    
            _THIS.submitForm($("#address_form_new"),e,"new");
        })

        $("input[name='address[company]']").each(function(){
            
            $(this).on("blur",function(){
                if($(this).val().length > 0){
                    if($(this).val().indexOf(":")!==-1){
                        $(this).val($(this).val().split(":").join("-"))
                    }
                    
                }
            })
            
        });


        $("select[name='address[country]']").each(function(){
            
            $(this).on("change",function(){
                $(this).closest("form").find("input[name='address[phone]']").removeClass("invalid").removeClass("valid")
                $(this).closest("form").find("input[name='address[phone]']").trigger("blur")   
            })
            
        });



        $("input[name='address[phone]']").each(function(){
            
            $(this).on("focus",function(){
                if($(this).val().length ==0){
                    $(this).val(theme.devSettings.phoneCountryCode)
                }
            })
            
        });

        (async () => {
            const { phoneValidate } = await import(theme.components.commonURL);

            //Phone Validation to ADD Form
            var instAddPhoneValidate = new phoneValidate();
            instAddPhoneValidate.init("#address_form_new input[name='address[phone]']",false,_THIS.addForm.find("input[type=submit]"),function(isphonevalid){
            
                if(isphonevalid){
                    _THIS.addForm.find("input[type=submit]").prop("disabled",false)
                }
            })	
        })();  


    }



    this.showAddressEditForm = function(elem){


        var whichForm = elem.attr('data-form-id')
        $("#EditAddress_" + whichForm).removeClass("hide")
        $(".edit-address-wrapper").removeClass("hide")
        $(".add-address-wrapper").addClass("hide")
        $(".intro").addClass("hide")
        $(".add-new-address-button").addClass("hide")
        $(".edit-address-list").addClass("hide")
        $(".edit-address-forms").removeClass("hide");
        _THIS.insEditPhoneValidaton = null;
        _THIS.instCommonEdit = null;

        _THIS.instCommonEdit = new myAccountCommon();
        _THIS.instCommonEdit.initForm($("#EditAddress_" + whichForm));
        _THIS.instCommonEdit.hideFormErrors();

        (async () => {
            const { phoneValidate } = await import(theme.components.commonURL);

            //Phone Validation to ADD Form
            _THIS.insEditPhoneValidaton = new phoneValidate();
            _THIS.insEditPhoneValidaton.init("#EditAddress_" + whichForm + " input[name='address[phone]']",false,$("#EditAddress_" + whichForm).find("input[type=submit]"),function(isphonevalid){
            
                if(isphonevalid){
                    $("#EditAddress_" + whichForm).find("input[type=submit]").prop("disabled",false)
                }
            })	
        })();  
        
          
    
        window.scrollTo(0, 0);

    }

        

    this.deleteAddress = function(elem){
        var addId = elem.attr("data-form-id");

      
        (async () => {
            const { setFancyConfirm } = await import(theme.components.commonURL);
            setFancyConfirm(function(){

                // Open customized confirmation dialog window
                $.fancyConfirm({
                    title     : theme.strings.customer.pages.addresses.deleteAddress,
                    message   : theme.strings.customer.pages.addresses.deleteConfirm,
                    okButton  : theme.strings.customer.pages.addresses.okBtn,
                    noButton  : theme.strings.customer.pages.addresses.cancelBtn,
                    callback  : function (value) {
                        if (value) {
                            
                            Shopify.postLink(
                                window.Shopify.routes.root +  'account/addresses/'+addId, 
                                {'parameters': {'_method': 'delete'}}
                            );

                        } else {
                           // console.log("cancel")
                        }
                    }
                });


            });

        })();

    
    }


    this.cancelEditAddress = function(elem){
        $(".edit-address-forms > div").addClass("hide")
        $(".edit-address-forms").addClass("hide")
        $(".edit-address-list").removeClass("hide")
        $(".intro").removeClass("hide")
        $(".add-new-address-button").removeClass("hide")
        window.scrollTo(0, 0);
    }


    this.showAddressNewForm = function(elem){
        _THIS.instCommonAdd.hideFormErrors();
        elem.parent().addClass("hide")
        $(".edit-address-wrapper").addClass("hide")
        $(".add-address-wrapper").removeClass("hide")
        $("#AddAddress").removeClass("hide");
        window.scrollTo(0, 0);

    }


    this.hideAddressNewForm = function(elem){

        //$("#address_form_new .form-message").remove();
        $("#address_form_new input[type=text]").removeClass("invalid").val("");
        $("#address_form_new input[type=tel]").removeClass("invalid").val("");
        $("#address_form_new select").removeClass("invalid")

        $(".edit-address-wrapper").removeClass("hide")
        $(".add-address-wrapper").addClass("hide")
        $("#AddAddress").addClass("hide");
        $(".intro").removeClass("hide")
        $(".add-new-address-button").removeClass("hide")
        window.scrollTo(0, 0);
    }


    this.submitForm = function(form,e,formtype){

        
        var validFormResult = _THIS.validateForm(form,formtype);

        
        e.preventDefault();
        if(!validFormResult.isFormValid){
            if(formtype == "edit"){
                _THIS.instCommonEdit.displayFormErrors(validFormResult.messages.error)
            }else{
                _THIS.instCommonAdd.displayFormErrors(validFormResult.messages.error)
            }
            
        }else{
            form.submit();
       }
    }


    this.validateForm = function(form,formtype){

        if(formtype == "edit"){
            _THIS.instCommonEdit.hideFormErrors();
        }else{
            _THIS.instCommonAdd.hideFormErrors();
            
        }
        
        

        var retObj = {
            isFormValid: true,
            messages:{
                error: [],
                success:[] 
            }
        }

        var mandatoryFields = ["input[name='address[first_name]']", "input[name='address[last_name]']", "input[name='address[address1]']", 
            "input[name='address[city]']","select[name='address[country]']","input[name='address[phone]']"]
        if(form.find($("select[name='address[province]']:visible")).length >0){
            mandatoryFields.push("select[name='address[province]']")
        }

        if(_THIS.isPostCodeMandatory){
            mandatoryFields.push("input[name='address[zip]']")
        }

        for(var i=0;i<mandatoryFields.length;i++){
            var fld = form.find(mandatoryFields[i])
            var fldVal = fld.val();
            if($.trim(fldVal).length <= 0 || fldVal=="---" ) {
                fld.addClass("invalid")
                retObj.isFormValid = false;
            }else{
                fld.removeClass("invalid")
            }
        }


        if(!retObj.isFormValid){
            retObj.messages.error.push(theme.forms.general.mandatory)
        }

        return retObj; 
    }

}

export function myAccountRegister(){
    var _THIS = this;
    this.emailhasValidated = false;
    this.phonehasValidated = false;
    this.formString = "#create_customer";
    this.form = $(_THIS.formString)
    this.instCommon = new myAccountCommon();
    this.instCommon.initForm(this.form)

    this.init=function(){
        //console.log("initialising My Account Register")
        registerEvents();


        if(theme.loyalty.enable){
            _THIS.instCommon.loyaltyCreateHiddenFields(_THIS.form)
        }

        _THIS.instCommon.initPasswordFields();
    }    

    var registerEvents  = function(){
        
        //initialise the email and phone validation


        (async () => {
            const { emailValidate, phoneValidate } = await import(theme.components.commonURL);


            var instEmailValidate = new emailValidate();
            instEmailValidate.init($("#Email"),_THIS.form.find("input[type=submit]"),function(isemailvalid){
                _THIS.emailhasValidated = isemailvalid;

                if($("#Mobile").length <= 0){
                    _THIS.phonehasValidated = true;
                }


                if( _THIS.phonehasValidated && _THIS.emailhasValidated){
                    _THIS.form.find("input[type=submit]").prop("disabled",false)
                }
            })

            if($("#Email").val()!==""){
                $("#Email").trigger("blur")
            }


            if($("#Mobile").length > 0){
                $(document).on("focus","#Mobile",function(){
          if($(this).val().length ==0){
            $(this).val(theme.devSettings.phoneCountryCode)
          }
        })

                var instPhoneValidate = new phoneValidate();
                instPhoneValidate.init("#Mobile",false,_THIS.form.find("input[type=submit]"),function(isphonevalid){
          _THIS.phonehasValidated = isphonevalid;
          if(_THIS.phonehasValidated && _THIS.emailhasValidated){
            _THIS.form.find("input[type=submit]").prop("disabled",false)
          }
        })	

            }


        })();


        //
        $(document).on("click","#create_customer input[type=submit]",function(e){
            _THIS.submitForm(e);
        })


        $(document).on("keyup","#create_customer #CreatePassword",function(){
            _THIS.instCommon.validatePassWord("#CreatePassword");
        })   


        $(document).on("change",".wrap-custom-dob select",function(){
        
            var y =	$(".wrap-custom-dob .selyear").val()
            var m =	$(".wrap-custom-dob .selmonth").val() 		
            var d =	$(".wrap-custom-dob .selday").val()

            var dateString = y + m + d;
            if(dateString.length == 8){

                /*if(typeof(_rejoiner)!== 'undefined'){
                    _rejoiner.push(['setCustomerData', { birthdate: y +  "-" +  m + "-" +  d ,language: (Shopify.locale || '').substr(0, 2)}]);
                }*/

                //Implement Insider Here
            }
            
        })


        $(document).on("change","#Marketing",function(){
            var isChecked = $(this).prop("checked")
            var getListRejoinerID = "";
            

            if(isChecked){
                getListRejoinerID = theme.devSettings.rejoinerSubscribeListID;
            }else{
                if(theme.devSettings.rejoinerUnSubscribeListID !== ""){
                    getListRejoinerID = theme.devSettings.rejoinerUnSubscribeListID;
                }else{
                    getListRejoinerID = theme.devSettings.rejoinerSubscribeListID;
                }
                
            }

            /*if(typeof(_rejoiner)!== 'undefined'){
                if(getListRejoinerID!==""){
                    _rejoiner.push(['subscribeToList', { email: $("#Marketing").closest("form").find("#Email").val(),list_id: getListRejoinerID,language: (Shopify.locale || '').substr(0, 2) }]);
                }
                
            }*/
            //Implement Insider Here

           


            if (typeof(gtag) != "undefined") {
                if(isChecked){
                    //ga('send', 'event', 'Newsletter', 'Subscribe','Register');
                    gtag('event','Subscribe',{
                        'category':'Newsletter',
                        'label':'Register'
                    })
                }else{
                    //ga('send', 'event', 'Newsletter', 'UnSubscribe','Register');
                    gtag('event','UnSubscribe',{
                        'category':'Newsletter',
                        'label':'Register'
                    })
                }
            }
        })

    }


    this.submitForm = function(e){
        
   
        var validFormResult = _THIS.validateForm();
        e.preventDefault();
        if(!validFormResult.isFormValid){
            _THIS.instCommon.displayFormErrors(validFormResult.messages.error)
        }else{
            if(theme.loyalty.enable == true){
                
                if( _THIS.form.find("input[name='bt_check']").length > 0){
                    if(_THIS.form.find("input[name='bt_check']").val()!==""){
                        return;
                    }
                };

                (async () => {
                    const { UISubmitRegisterForm } = await import(theme.components.loyaltyURL);
                    //console.log("submitting to loyalty")
                    UISubmitRegisterForm(_THIS.formString);
                    
                })();



                //console.log("submitting to loyalty")


            }else{
                _THIS.form.submit();
               // console.log("submitting to Shopify")
            }
        }
    }


    this.validateForm = function(){

        _THIS.instCommon.hideFormErrors();

        var retObj = {
            isFormValid: true,
            messages:{
                error: [],
                success:[] 
            }
        }

        var mandatoryFields = ["#FirstName", "#LastName", "#selday", "#selmonth", "#selyear", "#Email", "#CreatePassword"]
        if(_THIS.form.find("#Mobile").length >0 ){
            mandatoryFields.push("#Mobile")
        }

        for(var i=0;i<mandatoryFields.length;i++){
            var fld = _THIS.form.find(mandatoryFields[i])
            var fldVal = fld.val();
            if($.trim(fldVal).length <= 0) {
                fld.addClass("invalid")
                retObj.isFormValid = false;
            }else{
                fld.removeClass("invalid")
            }
        }

        
        var isPasswordValid = _THIS.instCommon.validatePassWord("#CreatePassword") 

        //Check Password Valid
        if(!isPasswordValid){
            retObj.isFormValid = false;
        }
        
        if(_THIS.form.find("#Mobile").length >0 ){
            if(!_THIS.form.find("#Mobile").hasClass("valid")){
                _THIS.form.find("#Mobile").addClass("invalid")
                retObj.isFormValid = false;    
            }
        }

        if(!_THIS.form.find("#Email").hasClass("valid")){
            _THIS.form.find("#Email").addClass("invalid")
            retObj.isFormValid = false;    
        }



        if(!retObj.isFormValid){
            retObj.messages.error.push(theme.forms.general.mandatory)
        }

        return retObj; 
    }


    
    
}

export function myAccountLanding(){
    var _THIS = this;
    
    this.init=function(){
        //console.log("initialising My Account Landing")
        registerEvents();
    }    


    var registerEvents  = function(){
        
    }

}




export function myAccountOrders(){
    var _THIS = this;
    
    this.init=function(){
       // console.log("initialising My Account Orders")
        registerEvents();
    }    


    var registerEvents  = function(){
        
    }

}


export function myAccountViewOrder(){
    var _THIS = this;
    
    this.init=function(){
        //console.log("initialising My Account View Order")
        registerEvents();
    }    


    var registerEvents  = function(){
        
    }

}

export function myAccountActivateAccount(){
    var _THIS = this;
    
    this.init=function(){
       // console.log("initialising My Account Activate Account")
        registerEvents();
    }    


    var registerEvents  = function(){
        
    }

}

/** Special case for creating a seperate function for memberson reset password
 * as the UI contains 2 forms
 * 1 for verify and the other for updating password
 * This makes code cleaner and easier to manage
 */
export function myAccountLoyaltyResetPassword(){
    var _THIS = this;
    this.formString = "#verify_password";
    this.instCommon = new myAccountCommon();


    this.init=function(){
        //console.log("initialising Memerson Reset Password Account")
        _THIS.registerEvents();
        _THIS.instCommon.initPasswordFields();
    }    


    this.registerEvents  = function(){

        (async () => {
            const { UIInitVerifyPasswordForm } = await import(theme.components.loyaltyURL);
        
            UIInitVerifyPasswordForm(_THIS.formString);
            
        })();

    }

}


export function myAccountResetPasswordAccount(){
    /**  User click on password reset link and redirect to reset password */
    var _THIS = this;

    this.form = $("#reset_customer_password")
    this.instCommon = new myAccountCommon();
    this.instCommon.initForm(this.form)

    this.init=function(){
       // console.log("initialising Reset Password Account")
        registerEvents();
        _THIS.instCommon.initPasswordFields();

    }    


    var registerEvents  = function(){

        $(document).on("keyup","#reset_customer_password #ResetPassword",function(){
            _THIS.instCommon.validatePassWord("#ResetPassword");
        })   

        $(document).on("keyup","#reset_customer_password #PasswordConfirmation",function(){
            _THIS.instCommon.validatePassWord("#PasswordConfirmation");
        })   

        $(document).on("click","#reset_customer_password input[type=submit]",function(e){
            _THIS.submitForm(e);
        })
    }    


    this.submitForm = function(e){
       // console.log("submitting Forms")
        e.preventDefault();
        var validFormResult = _THIS.validateForm();
      
        
        
        if(!validFormResult.isFormValid){
            _THIS.instCommon.displayFormErrors(validFormResult.messages.error)
            return false;
        }else{
            //if(theme.loyalty.enable == true){
            //    
             //   console.log("submitting to loyalty")


           // }else{
                _THIS.form.submit();
              //  console.log("submitting to Shopify")
            //}
        }
    }


    this.validateForm = function(){

        _THIS.instCommon.hideFormErrors();

        var retObj = {
            isFormValid: true,
            messages:{
                error: [],
                success:[] 
            }
        }

        var mandatoryFields = ["#ResetPassword", "#PasswordConfirmation"]
        var mandatoryField = true;

        for(var i=0;i<mandatoryFields.length;i++){
            var fld = _THIS.form.find(mandatoryFields[i])
            var fldVal = fld.val();
            if($.trim(fldVal).length <= 0) {
                fld.addClass("invalid")
                mandatoryField = false;
                //retObj.isFormValid = false;
            }else{
                fld.removeClass("invalid")
            }
        }

        var passwordMatch = true;
        var passwordValid = true;
        
        var isPasswordResetValid = _THIS.instCommon.validatePassWord("#ResetPassword") 
        var isPasswordConfirmValid = _THIS.instCommon.validatePassWord("#PasswordConfirmation") 

        //Check Password Valid
        if(!isPasswordResetValid || !isPasswordConfirmValid){
            passwordValid = false;
            //retObj.isFormValid = false;
        }else{
            passwordValid = true;
            if(_THIS.form.find("#ResetPassword").val()!==_THIS.form.find("#PasswordConfirmation").val()){
                passwordMatch = false;
                //retObj.isFormValid = false;
                //retObj.messages.error.push(theme.forms.general.passwordNotMatch)
            }else{
                passwordMatch = true;
                //retObj.isFormValid = true;
            }
        }
        

        if(!passwordValid || !mandatoryField){
            retObj.isFormValid = false;
            retObj.messages.error.push(theme.forms.general.mandatory)
        }else{
            if(!passwordMatch){
                retObj.isFormValid = false;
                retObj.messages.error.push(theme.forms.general.passwordNotMatch)
            }
        }

        return retObj; 
    }



}

export function myAccountResetPassword(){
    /** Send Password reset link to logged in User */
    var _THIS = this;
    
    this.init=function(){
        //console.log("initialising My Reset Password")
        registerEvents();
    }    


    var registerEvents  = function(){
    }
}



export function myAccountMembers(){
    var _THIS = this;
    this.instCommon = new myAccountCommon();
    this.init=function(){
       // console.log("initialising My Members")
        registerEvents();
        _THIS.loadMemberInformation();
    }    

    this.loadMemberInformation = function(){
        if(theme.loyalty.enable == true){
            if(theme.isUserLoggedIn && theme.userEmailAddress!==''){        

                (async () => {
                    const { getMemberInfo, getMemberMeta,showContentLoader, hideContentLoader,UIdisplayMemberInfoSummary,showFormErrorMessage } = await import(theme.components.loyaltyURL);
                    showContentLoader();

                    getMemberInfo(theme.userEmailAddress,'membershipsummary',function(memberdata){

                        if(memberdata !== null){
                            if(memberdata.IsSuccess == true){
                                //We now need to get the corresponding customer info from the customer object
                                getMemberMeta(function(membermetadata){
                                    if(membermetadata!==null){
                                        UIdisplayMemberInfoSummary(membermetadata,$('.member-wrapper .member-inner-wrapper'),false);
                                    }else{
                                        showFormErrorMessage('.member-wrapper',"<ul><li>" + theme.loyalty.sys_error_text + "</li></ul>")
                                        
                                    }
    
                                    hideContentLoader();
                                })	
                            }else{
                                showFormErrorMessage('.member-wrapper',"<ul><li>" + memberdata.Message + "</li></ul>")
    
                                if(memberdata.Result!==null && typeof(memberdata.Result.RedirectUrl)!=='undefined'){
                                    if(memberdata.Result.RedirectUrl!==""){
                                        setTimeout(function(){
                                            window.location.href =  memberdata.Result.RedirectUrl;
                                        },2000)
    
                                    }
                                }							
    
                                hideContentLoader();
                            }   
                        }else{
                            showFormErrorMessage('.member-wrapper',"<ul><li>" + theme.loyalty.sys_error_text + "</li></ul>")
                            hideContentLoader();
                        }			

                    })
                    
                })();
    

            }                
        }
    }

    var registerEvents  = function(){
        
    }


}


export function myAccountVouchers(){
    var _THIS = this;
    this.instCommon = new myAccountCommon();
    this.init=function(){
       // console.log("initialising My Vouchers")
        registerEvents();
        _THIS.loadMemberInformation();
    }    

    this.loadMemberInformation = function(){
        if(theme.loyalty.enable == true){
            if(theme.isUserLoggedIn && theme.userEmailAddress!==''){        

                (async () => {
                    const { getMemberInfo, getVoucher, getMemberMeta,showContentLoader, hideContentLoader,UIdisplayMemberInfoSummary,UIdisplayVoucherList, showFormErrorMessage } = await import(theme.components.loyaltyURL);
                    showContentLoader();

                    getMemberInfo(theme.userEmailAddress,'membershipsummary',function(memberdata){

                        if(memberdata !== null){
                            if(memberdata.IsSuccess == true){
                                //We now need to get the corresponding customer info from the customer object
                                getMemberMeta(function(membermetadata){
                                    if(membermetadata!==null){
                                        UIdisplayMemberInfoSummary(membermetadata,$('.member-wrapper .member-inner-wrapper'),true);

                                        var btcheck = "";
  
                                        if($('.member-wrapper').find("input[name='bt_check']").length > 0){
                                            btcheck = $('.member-wrapper').find("input[name='bt_check']").val()
                                        }
                                        

                                        //Voucher List
                                        getVoucher(theme.userEmailAddress,theme.loyalty.tier.toLowerCase(),btcheck,function(voucherdata){
                                            if(voucherdata !== null){
                                                if(voucherdata.IsSuccess == true){
                                                    //We now need to get the corresponding customer info from the customer object
                                                    getMemberMeta(function(membervouchermetadata){
                                                        if(membervouchermetadata!==null){
                                                            
                                                            UIdisplayVoucherList(membervouchermetadata,$(".vouchers-wrapper-inner"))
                        
                                                        }else{
                                                            showFormErrorMessage('.member-wrapper',"<ul><li>" + theme.loyalty.sys_error_text + "</li></ul>")
                                                        }
                        
                                                        hideContentLoader();
                                                    })	
                                                }else{

                                                    showFormErrorMessage('.member-wrapper',"<ul><li>" + voucherdata.Message + "</li></ul>")
                        
                                                    if(typeof(voucherdata.Result.RedirectUrl)!=='undefined'){
                                                        if(voucherdata.Result.RedirectUrl!==""){
                                                            setTimeout(function(){
                                                                window.location.href =  voucherdata.Result.RedirectUrl;
                                                            },2000)
                        
                                                        }
                                                    }							
                        
                                                    hideContentLoader();
                                                }   
                                            }else{
                                                hideContentLoader();
                                            }					
                      })
                                    }else{
                                        showFormErrorMessage('.member-wrapper',"<ul><li>" + theme.loyalty.sys_error_text + "</li></ul>")
                                    }
    
                                    hideContentLoader();
                                })	
                            }else{
                                showFormErrorMessage('.member-wrapper',"<ul><li>" + memberdata.Message + "</li></ul>")
    
                                if(memberdata.Result!==null && typeof(memberdata.Result.RedirectUrl)!=='undefined'){
                                    if(memberdata.Result.RedirectUrl!==""){
                                        setTimeout(function(){
                                            window.location.href =  memberdata.Result.RedirectUrl;
                                        },2000)
    
                                    }
                                }							
    
                                hideContentLoader();
                            }   
                        }else{
                            showFormErrorMessage('.member-wrapper',"<ul><li>" + theme.loyalty.sys_error_text + "</li></ul>")
                            hideContentLoader();
                        }			

                    })
                    
                })();
    

            }                
        }
    }



    this.selectPoints = function(voucherData){
       
            var htmlMData =""
            htmlMData += '<div id="select-points-content">'
            htmlMData +=    '<button id="close-select-points-popup" data-fancybox-close="" class="fancybox-close-small" title="Close"></button>'
            htmlMData += 	'<div id="voucher-list">'
            htmlMData += 	'<h3>' + theme.strings.customer.pages.vouchers.titleAvailableVouchers + '</h3>'
            htmlMData += 	'	<table class="striped">'
            //htmlMData += 	'		<thead>'
            //htmlMData += 	'			<tr>'
            //htmlMData += 	'				<th class="voucherCell" colspan="2">'+theme.strings.customer.pages.vouchers.titleAvailableVouchers + '</th>'
            //htmlMData += 	'			</tr>'
            //htmlMData += 	'		</thead>'
            htmlMData += 	'		<tbody>'
    
            for(var j=0;j<voucherData.length;j++){
                htmlMData += '			<tr class="voucherrow">'
                htmlMData += '				<td class="voucherCell"><div class="voucherName"><strong>' + ((voucherData[j].VoucherName!=="" && voucherData[j].VoucherName!==null)?voucherData[j].VoucherName:"") + '</strong></div>'
                //htmlMData += '				<div class="voucherCode"><span>Code:</span> ' + ((voucherData[j].VoucherNumber!=="" && voucherData[j].VoucherNumber!==null)?voucherData[j].VoucherNumber:"")  + '</div>'
                //htmlMData += '				<div class="voucherCost"><span>Balance:</span> '+ 	((voucherData[j].DenominationValue!=="" && voucherData[j].DenominationValue!==null )?Shopify.formatMoney((voucherData[j].DenominationValue*100),theme.moneyFormatWithCurrency):"") +'</div>'
                //htmlMData += '				<div class="voucherExpiry"><span>Expiry:</span> '+ 	((voucherData[j].ExpiryDate!=="" && voucherData[j].ExpiryDate!==null)?formatDateToLocal(voucherData[j].ExpiryDate,false):"")  +'</div>'
                htmlMData += '					<div class="voucherPoints"><span>' + theme.strings.customer.pages.member.points + ':</span> ' + ((voucherData[j].CostValue!=="" && voucherData[j].CostValue!==null)?voucherData[j].CostValue:"")  + '</div>'				
                
                htmlMData += '				</td>'
                htmlMData += '				<td class="convertCell text-right">'
                //htmlMData += '					<button data-type="voucher" data-voucher-number="' + ((voucherData[j].VoucherNumber!=="" && voucherData[j].VoucherNumber!==null)?voucherData[j].VoucherNumber:"") + '" data-token="' +  ((voucherData[j].VoucherAppToken!=="" && voucherData[j].VoucherAppToken!==null)?voucherData[j].VoucherAppToken:"") + '" type="button" class="redeembtn voucher btn btn-sm"><span class="btn__content">Redeem</span></button>'								
                htmlMData += '					<button data-type="voucher" data-voucherCode="' + voucherData[j].VoucherCode + '" data-memberno="' +$("#btn-select-points").attr("data-memberno") + '" data-costvalue="'  + voucherData[j].CostValue + '" data-moneyvalue="' + voucherData[j].DenominationValue + '" type="button" class="convertbtn voucher btn btn-black sm">'+ theme.strings.customer.pages.vouchers.convertBtn + '</button>'								
    
    
                htmlMData += '					<input type="text" name="bt_check" value="" style="display:none !important" tabindex="-1" autocomplete="off">'
                htmlMData += '				</td>'
                htmlMData += '			</tr>'
            }	
    
            htmlMData += 	'		</tbody>'
            htmlMData += 	'	</table">'
            htmlMData += 	'</div>'
            /*htmlMData +=	'<div class="footer"><div class="notification-controls">'
            htmlMData +=		'<a id="cancel-select-points" class="btn btn-grey select-cancel" href="#">Cancel</a>'		
            htmlMData +=	'</div></div>'*/
            htmlMData += '</div>';
    
            (async () => {
                const { checkLibrary } = await import(theme.components.commonURL);
                checkLibrary($.fancybox, theme.components.modalLibraryURL, function(){

                    $.fancybox.open(htmlMData,{
                        modal:true,
                        afterShow : function( instance, current ) {
                        }	
                    });
        
                    
                })
                
            })();

    }


    this.continueRedeem =  function (elem) {
        var getVoucherNumber = elem.attr("data-voucher-number");
        var getToken = elem.attr("data-token");
    
        var btcheck = "";
        if (elem.parent().find("input[name='bt_check']").length > 0) {
          btcheck = elem.parent().find("input[name='bt_check']").val();
        }
    
        if (
          getVoucherNumber !== "" &&
          getToken !== "" &&
          theme.userEmailAddress !== ""
        ) {
          (async () => {
            const {
              redeemVoucher,
              showContentLoader,
              hideContentLoader,
              showFormErrorMessage,
            } = await import(theme.components.loyaltyURL);
    
            redeemVoucher(
              theme.userEmailAddress,
              getVoucherNumber,
              getToken,
              btcheck,
              function (response) {
                if (response !== null) {
                  if (response.IsSuccess == true) {
                    var getCode = response.Result;
    
                    if (getCode !== "") {

                        setTimeout(function(){
                            //	window.location.href = window.location.href; 
                                $(document.body).append("<script>window.location.reload();</script>")
        
                         },2000) 

                      /*$(
                        "#vouchers-list-template .redeem-loader-content"
                      ).removeClass("hide");
                      $("#checkout_reduction_code").val(getCode); //.closest("form").submit();
                      $(
                        ".order-summary__section--discount .field__input-btn-wrapper button"
                      )
                        .prop("disabled", false)
                        .trigger("click");
                      setTimeout(function () {
                        $("#close-voucher-list-popup").trigger("click");
                      }, 2000);*/
                      
                    }
                  } else {
                    showFormErrorMessage(
                      "#vouchers-list-template .notification-message",
                      "<ul><li>" + response.Message + "</li></ul>"
                    );
    
                    if (typeof response.Result.RedirectUrl !== "undefined") {
                      if (response.Result.RedirectUrl !== "") {
                        setTimeout(function () {
                          window.location.href = response.Result.RedirectUrl;
                        }, 2000);
                      }
                    }
                    $("#vouchers-list-template .redeem-loader-content").addClass(
                      "hide"
                    );
                    showFormErrorMessage(
                      "#vouchers-list-template .notification-message",
                      "<ul><li>" + response.Message + "</li></ul>"
                    );
                  }
                } else {
                  $("#vouchers-list-template .redeem-loader-content").addClass(
                    "hide"
                  );
                  showFormErrorMessage(
                    "#vouchers-list-template .notification-message",
                    "<ul><li>" + theme.loyalty.sys_error_text + "</li></ul>"
                  );
                }
              }
            );
          })();
        }
      }


    this.displayVoucherListPopup = function (elem) {
        var htmlWrapper = "";
        htmlWrapper += '<div id="vouchers-list-template" class="vouchers-list">';
        htmlWrapper +=
          '<button id="close-voucher-list-popup" data-fancybox-close="" class="fancybox-close-small" title="Close"></button>';
        htmlWrapper += '<div class="redeem-loader-content hide">';
        htmlWrapper += '<img src="' + theme.loaderImage + '" />';
        htmlWrapper += "</div>";
        htmlWrapper += '<div class="notification-message hide">';
        htmlWrapper +=
          '<div class="form-message form-message--error hide"><div class="errors"></div></div>';
        htmlWrapper +=
          '<div class="form-message form-message--success hide"><div class="success"></div></div>';
        htmlWrapper += "</div>";
        htmlWrapper += '<div class="notification hide">';
        htmlWrapper += '<div class="notification-wrap">';
        htmlWrapper += '<div class="notification-content">';
        htmlWrapper +=
          '<div class="form-message form-message--error hide"><div class="errors"></div></div>';
        htmlWrapper +=
          '<div class="form-message form-message--success hide"><div class="success"></div></div>';
        htmlWrapper +=
          "<h3>" + theme.strings.customer.pages.vouchers.onlineVoucher + "</h3>";
        htmlWrapper +=
          "<p>" +
          theme.strings.customer.pages.vouchers.voucherRedeemMessage +
          "</p>";
        htmlWrapper += "</div>";
        htmlWrapper += '<div class="notification-controls">';
        htmlWrapper +=
          '<a class="btn btn-black notif-cancel outline" href="#">' +
          theme.strings.customer.pages.vouchers.cancelBtn +
          "</a>&nbsp;";
        htmlWrapper +=
          '<a class="btn btn-black notif-continue" href="#">' +
          theme.strings.customer.pages.vouchers.continueBtn +
          "</a>";
        htmlWrapper +=
          '<input type="text" name="bt_check" value="" style="display:none !important" tabindex="-1" autocomplete="off">';
        htmlWrapper += "</div>";
        htmlWrapper += "</div>";
        htmlWrapper += "</div>";
        htmlWrapper += '<div class="wrap-content">';
        htmlWrapper += '<div class="inner-wrap">';
        htmlWrapper += '<div class="loader-content">';
        htmlWrapper += '<img src="' + theme.loaderImage + '" />';
        htmlWrapper += "</div>";
        htmlWrapper +=
          '<div class="form-message form-message--error hide"><div class="errors"></div></div>';
        htmlWrapper +=
          '<div class="form-message form-message--success hide"><div class="success"></div></div>';
        htmlWrapper += "</div>";
        htmlWrapper += "</div>";
        htmlWrapper += "</div>";
    
        (async () => {
          const { checkLibrary } = await import(theme.components.commonURL);
          checkLibrary($.fancybox, theme.components.modalLibraryURL, function () {
            $.fancybox.open(htmlWrapper, {
              modal: true,
              beforeShow:function(instance,current){

              },
              afterShow: function (instance, current) {

                $(
                    "#vouchers-list-template .notification-message .form-message--error"
                  ).addClass("hide");
                  $("#vouchers-list-template .notification-message").addClass("hide");
              
                  $("#vouchers-list-template .notification").removeClass("hide");
                  $("#vouchers-list-template .wrap-content").addClass("hide");
                  $("#vouchers-list-template .notif-continue").attr(
                    "data-voucher-number",
                    elem.attr("data-voucher-number")
                  );
                  $("#vouchers-list-template .notif-continue").attr(
                    "data-token",
                    elem.attr("data-token")
                  );
              },
            });
          });
        })();
      }
    

      

    this.showNotificationRedeem = function(elem){

    }

    this.convertPoints = function(){

    }

    var registerEvents  = function(){


        /** Redeem */



        $(document).on(
            "click",
            "#vouchers-list-template .notif-continue",
            function (e) {
              e.preventDefault();
    
              if ($(this).parent().find("input[name='bt_check']").length > 0) {
                if ($(this).parent().find("input[name='bt_check']").val() !== "") {
                  return;
                }
              }
    
              $("#vouchers-list-template .notification").addClass("hide");
              $("#vouchers-list-template .wrap-content").removeClass("hide");
              $("#vouchers-list-template .redeem-loader-content").removeClass(
                "hide"
              );
              _THIS.continueRedeem($(this));
            }
          );


          $(document).on(
            "click",
            "#vouchers-list-template .notif-cancel",
            function (e) {
              e.preventDefault();
              $("#close-voucher-list-popup").trigger("click")
            }
          );
        


        $(document).on("click", "button.redeembtn", function (e) {
            e.preventDefault();
    
            if ($(this).parent().find("input[name='bt_check']").length > 0) {
              if ($(this).parent().find("input[name='bt_check']").val() !== "") {
                return;
              }
            }
            _THIS.displayVoucherListPopup($(this));
          });
     
        
        $(document).on("click","#btn-select-points",function(e){
            e.preventDefault();
            $(this).attr("data-vouchercode","")
            _THIS.selectPoints(JSON.parse($(this).attr("data-voucherdata")))
         })
    
    
         $(document).on("click","#cancel-select-points",function(e){
            e.preventDefault();
            $("#close-select-points-popup").trigger("click")
        })
    
        $(document).on("click","#select-points-content .convertbtn",function(e){
            e.preventDefault();
            var _THIS = $(this);
    
            $("#btn-select-points").attr("data-vouchercode",$(this).attr("data-voucherCode"))	
    
            var htmlContent = "<div id='convert-points-content' class='text-center'>"
                htmlContent +=		'<div class="content-popup-loader">'
                htmlContent += 			'<img src="'  + theme.loaderImage + '" />'
                htmlContent +=		'</div>'
                htmlContent +=		'<button id="close-convert-points-popup-new" data-fancybox-close="" class="fancybox-close-small" title="Close"></button>'
                htmlContent +=		"<h3>" + theme.strings.customer.pages.vouchers.titleConvertVouchers + "</h3>"
                htmlContent +=		"<div class='intro'>"
                htmlContent +=		"<p>" + theme.strings.customer.pages.vouchers.pointsConvertMessage1 + _THIS.attr("data-costvalue") + theme.strings.customer.pages.vouchers.pointsConvertMessage2 + Shopify.formatMoney((_THIS.attr("data-moneyvalue")*100),theme.moneyFormatWithCurrency) + theme.strings.customer.pages.vouchers.pointsConvertMessage3 + "</p>"	
                htmlContent +=			'<div class="notification-controls">'
                htmlContent +=				'<a id="cancel-convert-points-new" class="btn btn-black outline convert-cancel" href="#">' + theme.strings.customer.pages.vouchers.cancelBtn + '</a>&nbsp;'		
                htmlContent +=				'<a id="continue-convert-points-new" class="btn btn-black convert-continue" href="#">' + theme.strings.customer.pages.vouchers.continueBtn + '</a>'
                htmlContent +=				'<input type="text" name="bt_check" value="" style="display:none !important" tabindex="-1" autocomplete="off">'
                htmlContent +=			'</div>'
                htmlContent +=			'</div>'
    
                htmlContent +=		"<div class='result hide'>"		
                htmlContent +=		"</div>"
                
                htmlContent +=	"</div>"
    
                $("#close-select-points-popup").trigger("click");


                (async () => {
                    const { checkLibrary } = await import(theme.components.commonURL);
                    checkLibrary($.fancybox, theme.components.modalLibraryURL, function(){
    
                        $.fancybox.open(htmlContent,{
                            modal:true,
                            afterShow : function( instance, current ) {
            
                            }	
                        });		
                    
                        
                    })
                    
                })();
    


    
        })
    
        $(document).on("click","#cancel-convert-points-new",function(e){
            e.preventDefault();
            $("#btn-select-points").attr("data-vouchercode","")
            $("#close-convert-points-popup-new").trigger("click")
        })
    
        $(document).on("click","#continue-convert-points-new",function(e){
            e.preventDefault();
            var _THIS = $("#btn-select-points");
            
            if($(this).parent().find("input[name='bt_check']").length > 0){
                if($(this).parent().find("input[name='bt_check']").val()!==""){
                    return;
                }
            }
    
            //You are about to convert 300 pts into $SGD 50 voucher
            //loyaltyConfig.showContentLoader();
            $("#convert-points-content .intro").addClass("hide")
            $("#convert-points-content").addClass("show-content-popup-loader");
            $("#convert-points-content .result").removeClass("form-message--error form-message-success")
            $("#convert-points-content .result").html("<p>" + theme.strings.customer.pages.vouchers.convertingPointsMsg + "</p>").removeClass("hide")
    
            var btcheck = "";
            if($(this).parent().find("input[name='bt_check']").length > 0){
                btcheck = $(this).parent().find("input[name='bt_check']").val()
            };
            
            (async () => {
                const { pointsToVoucher } = await import(theme.components.loyaltyURL);

                pointsToVoucher(theme.userEmailAddress,_THIS.attr("data-memberno"),_THIS.attr("data-vouchercode"),btcheck,function(response){
                    if(response !== null){
                        if(response.IsSuccess == true){
                            var result = JSON.parse(response.Result);
                            
                            $("#convert-points-content .result").html("<p>" + theme.strings.customer.pages.vouchers.convertSuccessMsg1 + result[0].VoucherName + " <strong>" + result[0].VoucherNumber +  "</strong>" + theme.strings.customer.pages.vouchers.convertSuccessMsg2 + "</p>")
                            $("#convert-points-content .result").addClass("form-message--success")
                            $("#convert-points-content").removeClass("show-content-popup-loader");
                            setTimeout(function(){
                            //	window.location.href = window.location.href; 
                                $(document.body).append("<script>window.location.reload();</script>")
        
                            },3000) 
                        }else{
        
                            $("#convert-points-content .result").html("<ul><li>" + response.Message + "</li></ul>");
                            $("#convert-points-content .result").addClass("form-message--error")
        
                            if(response.Result!==null && typeof(response.Result.RedirectUrl)!=='undefined'){
                                if(response.Result.RedirectUrl!==""){
                                    setTimeout(function(){
                                        window.location.href =  response.Result.RedirectUrl;
                                    },2000)
        
                                }else{
                                    $("#convert-points-content").removeClass("show-content-popup-loader");
                                    
                                }
                            }else{
                                $("#convert-points-content").removeClass("show-content-popup-loader");
                                $("#convert-points-content .result").delay(5000).fadeOut(1000,"linear",function(){
                                    $("#convert-points-content .result").addClass("hide");
                                    $("#convert-points-content .result").removeClass("form-message--error")
                                    $("#convert-points-content .result").attr("style","")
                                    $("#convert-points-content .intro").removeClass("hide")
                
                                })
                            }
        
                        }   
                    }else{
                        $("#convert-points-content .result").html("<ul><li>" + theme.loyalty.sys_error_text + "</li></ul>");
                        $("#convert-points-content .result").addClass("form-message--error")
                        $("#convert-points-content").removeClass("show-content-popup-loader");
        
                        $("#convert-points-content .result").delay(5000).fadeOut(1000,"linear",function(){
                        $("#convert-points-content .result").addClass("hide");
                        $("#convert-points-content .result").removeClass("form-message--error")
                        $("#convert-points-content .result").attr("style","")
                        $("#convert-points-content .intro").removeClass("hide")
        
                        })
        
                    }
                })
    
                
                
            })();

            
        
        })
    
        /** new conversion code end*/
    
        $(document).on("click","#btn-convert-points",function(e){
            e.preventDefault();
    
            var _THIS = $(this);
    
            var htmlContent = "<div id='convert-points-content'>"
                htmlContent +=		'<div class="content-popup-loader">'
                htmlContent += 			'<img src="'  + theme.loaderImage + '" />'
                htmlContent +=		'</div>'
                htmlContent +=		'<button id="close-convert-points-popup" data-fancybox-close="" class="fancybox-close-small" title="Close"></button>'
                htmlContent +=		"<h3>" + theme.strings.customer.pages.vouchers.titleConvertVouchers + "</h3>"
                htmlContent +=		"<div class='intro'>"		
                htmlContent +=			"<p>" + theme.strings.customer.pages.vouchers.pointsConvertMessage1 + _THIS.attr("data-costvalue") + theme.strings.customer.pages.vouchers.pointsConvertMessage2 + Shopify.formatMoney((_THIS.attr("data-moneyvalue")*100),theme.moneyFormatWithCurrency) + theme.strings.customer.pages.vouchers.pointsConvertMessage3 + "</p>"		
                htmlContent +=			'<div class="notification-controls">'
                htmlContent +=				'<a id="cancel-convert-points" class="btn btn-grey convert-cancel" href="#">' + theme.strings.customer.pages.vouchers.cancelBtn + '</a>'		
                htmlContent +=				'<a id="continue-convert-points" class="btn btn-red convert-continue" href="#">' + theme.strings.customer.pages.vouchers.continueBtn + '</a>'
                htmlContent +=				'<input type="text" name="bt_check" value="" style="display:none !important" tabindex="-1" autocomplete="off">'
                htmlContent +=			'</div>'
                htmlContent +=		"</div>"
    
                htmlContent +=		"<div class='result hide'>"		
                htmlContent +=		"</div>"
                
                htmlContent +=	"</div>";


                (async () => {
                    const { checkLibrary } = await import(theme.components.commonURL);
                    checkLibrary($.fancybox, theme.components.modalLibraryURL, function(){
    
                        $.fancybox.open(htmlContent,{
                            modal:true,
                            afterShow : function( instance, current ) {
                
                            }	
                        });
            
                            
                        
                    })
                    
                })();

    
    
        })
    
        
        $(document).on("click","#cancel-convert-points",function(e){
            e.preventDefault();
            $("#close-convert-points-popup").trigger("click")
        })

        

        $(document).on("click","#continue-convert-points",function(e){

            e.preventDefault();
            var _THIS = $("#btn-convert-points");
            
            if($(this).parent().find("input[name='bt_check']").length > 0){
                if($(this).parent().find("input[name='bt_check']").val()!==""){
                    return;
                }
            }
    
            //You are about to convert 300 pts into HK$ 50 voucher
            //loyaltyConfig.showContentLoader();
            $("#convert-points-content .intro").addClass("hide")
            $("#convert-points-content").addClass("show-content-popup-loader");
            $("#convert-points-content .result").removeClass("form-message--error form-message-success")
            $("#convert-points-content .result").html("<p>" + theme.strings.customer.pages.vouchers.convertingPointsMsg + "</p>").removeClass("hide")
    
            var btcheck = "";
            if($(this).parent().find("input[name='bt_check']").length > 0){
                btcheck = $(this).parent().find("input[name='bt_check']").val()
            };


            (async () => {
                const { pointsToVoucher } = await import(theme.components.loyaltyURL);
              
                pointsToVoucher(theme.userEmailAddress,_THIS.attr("data-memberno"),_THIS.attr("data-vouchercode"),btcheck,function(response){
                    if(response !== null){
                        if(response.IsSuccess == true){
                            var result = JSON.parse(response.Result);
                            
                            $("#convert-points-content .result").html("<p>" + theme.strings.customer.pages.vouchers.convertSuccessMsg1 + result[0].VoucherName + " <strong>" + result[0].VoucherNumber +  "</strong>" + theme.strings.customer.pages.vouchers.convertSuccessMsg2 + "</p>")
                            $("#convert-points-content .result").addClass("form-message--success")
                            $("#convert-points-content").removeClass("show-content-popup-loader");
                            setTimeout(function(){
                            //	window.location.href = window.location.href; 
                                $(document.body).append("<script>window.location.reload();</script>")
        
                            },3000) 
                        }else{
        
                            $("#convert-points-content .result").html("<ul><li>" + response.Message + "</li></ul>");
                            $("#convert-points-content .result").addClass("form-message--error")
        
                            if(response.Result!==null && typeof(response.Result.RedirectUrl)!=='undefined'){
                                if(response.Result.RedirectUrl!==""){
                                    setTimeout(function(){
                                        window.location.href =  response.Result.RedirectUrl;
                                    },2000)
        
                                }else{
                                    $("#convert-points-content").removeClass("show-content-popup-loader");
                                    
                                }
                            }else{
                                $("#convert-points-content").removeClass("show-content-popup-loader");
                                $("#convert-points-content .result").delay(5000).fadeOut(1000,"linear",function(){
                                    $("#convert-points-content .result").addClass("hide");
                                    $("#convert-points-content .result").removeClass("form-message--error")
                                    $("#convert-points-content .result").attr("style","")
                                    $("#convert-points-content .intro").removeClass("hide")
                
                                })
                            }
        
                        }   
                    }else{
                        $("#convert-points-content .result").html("<ul><li>" + theme.loyalty.sys_error_text + "</li></ul>");
                        $("#convert-points-content .result").addClass("form-message--error")
                        $("#convert-points-content").removeClass("show-content-popup-loader");
        
                        $("#convert-points-content .result").delay(5000).fadeOut(1000,"linear",function(){
                        $("#convert-points-content .result").addClass("hide");
                        $("#convert-points-content .result").removeClass("form-message--error")
                        $("#convert-points-content .result").attr("style","")
                        $("#convert-points-content .intro").removeClass("hide")
        
                        })
                    }
                })
                
            })();
        })    

            
    }

}



export function myAccountWishlist(){
    var _THIS = this;
    
    this.init=function(){
       // console.log("initialising My Wishlist")
        registerEvents();
    }    


    var registerEvents  = function(){
        
    }

}

export function getAccountMembersInfo(sections){
    var _THIS = this;
    this.instCommon = new myAccountCommon();
    this.init=function(){
       // console.log("initialising My Members")
        registerEvents();
        _THIS.loadMemberInformation();
    }    

    this.loadMemberInformation = function(){
        if(theme.loyalty.promotion_slider_loyalty.enabled == true){
            if(theme.isUserLoggedIn && theme.userEmailAddress!==''){        

                (async () => {
                    const { getMemberInfo, getMemberMeta,showHeaderLoader, hideHeaderLoader,UIdisplayMemberName,showFormErrorMessage } = await import(theme.components.loyaltyURL);
                    showHeaderLoader();

                    getMemberInfo(theme.userEmailAddress,'membershipsummary',function(memberdata){

                        if(memberdata !== null){
                            if(memberdata.IsSuccess == true){
                                //We now need to get the corresponding customer info from the customer object
                                getMemberMeta(function(membermetadata){
                                    if(membermetadata!==null){
                                        if(sections == 'header'){
                                        var flag = 1;
                                        var elem = $('.is-loggedin .cus_name_members');
                                        }else{
                                        var flag = 0;
                                        var elem = $('.loyalty_slide .loyalty_text_con');
                                        }
                                        UIdisplayMemberName(membermetadata, elem, flag);
                                    }else{
                                        showFormErrorMessage('.member-wrapper',"<ul><li>" + theme.loyalty.sys_error_text + "</li></ul>")
                                        
                                    }
    
                                    hideHeaderLoader();
                                })	
                            }else{
                                showFormErrorMessage('.member-wrapper',"<ul><li>" + memberdata.Message + "</li></ul>")
    
                                if(memberdata.Result!==null && typeof(memberdata.Result.RedirectUrl)!=='undefined'){
                                    if(memberdata.Result.RedirectUrl!==""){
                                        setTimeout(function(){
                                            window.location.href =  memberdata.Result.RedirectUrl;
                                        },2000)
    
                                    }
                                }							
    
                                hideHeaderLoader();
                            }   
                        }else{
                            showFormErrorMessage('.member-wrapper',"<ul><li>" + theme.loyalty.sys_error_text + "</li></ul>")
                            hideHeaderLoader();
                        }			

                    })
                    
                })();
    

            }                
        }
    }

    var registerEvents  = function(){
        
    }


}

